import React, { useContext } from 'react';
import PartnerSlider from "./PartnerSlider";
import { LanguageContext } from "../languages/LanguageContext";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
    const { language, translations } = useContext(LanguageContext);

    const location = useLocation();
    const currentPage = location.pathname.substring(1);

    return (
        <footer>
            <div className='partner-container w-full max-w flex col'>
                <h2 className='flex jc-c w-full'>{translations[language]["partnerTitle"]}</h2>
                <PartnerSlider />
            </div>
            <div className='contact-container flex max-w jc-sb wrap gap-1'>
                <div>
                    <img src='/art/europe.png' alt=''/>
                </div>
                <div>
                    <h3>Information</h3>
                    <ul>
                        <li>
                            <Link className={currentPage === "" ? 'item active' : 'item'} to='/'>
                                {translations[language]["home"]}
                            </Link>
                        </li>
                        <li>
                            <Link className={currentPage === "news" ? 'item active' : 'item'} to='/news'>
                                {translations[language]["news"]}
                            </Link>
                        </li>
                        <li>
                            <Link className={currentPage === "press" ? 'item active' : 'item'} to='/press'>
                                {translations[language]["press"]}
                            </Link>
                        </li>
                        <li>
                            <Link className={currentPage === "contact" ? 'item active' : 'item'} to='/contact'>
                                {translations[language]["contact"]}
                            </Link>
                        </li>
                        <li>
                            <Link className={currentPage === "about" ? 'item active' : 'item'} to='/about'>
                                {translations[language]["about"]}
                            </Link>
                        </li>
                        <li>
                            <Link className={currentPage === "imprint" ? 'item active' : 'item'} to='/imprint'>
                                {translations[language]["imprint"]}
                            </Link>
                        </li>
                        <li>
                            <Link className={currentPage === "policy" ? 'item active' : 'item'} to='/policy'>
                                {translations[language]["privacy"]}
                            </Link>
                        </li>
                    </ul>
                </div>
                <div>
                    <h3>Erasmus+</h3>
                    <ul>
                        <li>
                            <Link className={currentPage === "projects" ? 'item active' : 'item'} to='/work'>
                                {translations[language]["internationalWork"]}
                            </Link>
                        </li>
                        <li>
                            <Link className={currentPage === "accommodation" ? 'item active' : 'item'} to='/accommodation'>
                                {translations[language]["accommodation"]}
                            </Link>
                        </li>
                        <li>
                            <Link className={currentPage === "graduates" ? 'item active' : 'item'} to='/graduates'>
                                {translations[language]["graduates"]}
                            </Link>
                        </li>
                        <li>
                            <Link className={currentPage === "friendbook" ? 'item active' : 'item'} to='/friendbook'>
                                {translations[language]["friendbook"]}
                            </Link>
                        </li>
                        <li>
                            <Link className={currentPage === "archive" ? 'item active' : 'item'} to='/archive'>
                                {translations[language]["archive"]}
                            </Link>
                        </li>
                        <li>
                            <Link className={currentPage === "videos" ? 'item active' : 'item'} to='/videos'>
                                Videos
                            </Link>
                        </li>
                    </ul>
                </div>
                <div>
                    <h3>{translations[language]["contact"]}</h3>
                    <ul className='contacts'>
                        <li>BVÖ - Bildungsberatung & Vermittlungsagentur GmbH</li>
                        <li>Ankershofenstraße 8, Stiege 2 9020 Klagenfurt am Wörthersee Kärnten/Österreich</li>
                        <li>aldona.biedermann@gmail.com</li>
                    </ul>
                </div>
            </div>
            <div className='copyright-container max-w flex jc-sb ai-c wrap gap-1'>
                <span>2026 © A. Biedermann</span>
                <div className='flex gap-2'>
                    <img src='/partners/learning.png' alt='learning-logo' />
                    <img src='/partners/erasmus-2.png' alt='erasmus-logo' />
                    <img src='/partners/oead.png' alt='erasmus-logo' />
                </div>
            </div>
        </footer>
    );
};

export default Footer;